





import Vue from "vue";

export default Vue.extend({
  name: "ContractDetailIndex",

  components: {
    RecruitmentAgencyAdministrationRole: () => import("./RecruitmentAgencyAdministrationRole/Index.vue"),
    ContractingRole: () => import("./ContractingRole/Index.vue"),
    AuthorisingRole: () => import("./AuthorisingRole/Index.vue"),
  },
});
